import { cn } from "@/utils/cn";
import { getPasswordRequirements, getPasswordScore, MIN_PASSWORD_LENGTH } from "@/utils/passwordStrength";

const SCORE_COLORS = ["bg-zinc-800", "bg-rose-500", "bg-amber-500", "bg-amber-400", "bg-emerald-500"];
const SCORE_LABELS = ["", "Weak", "Fair", "Good", "Strong"];

export default function PasswordStrengthMeter({ password }) {
  if (!password) return null;

  const score = getPasswordScore(password);
  const req = getPasswordRequirements(password);

  return (
    <div className="space-y-1.5">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={cn("h-1 flex-1 rounded-full transition-colors", i < score ? SCORE_COLORS[score] : "bg-zinc-800")}
          />
        ))}
      </div>
      <div className="flex items-center justify-between text-[9px] font-mono uppercase tracking-wider">
        <span className={cn("font-bold", score <= 1 ? "text-rose-400" : score <= 2 ? "text-amber-400" : "text-emerald-400")}>
          {SCORE_LABELS[score]}
        </span>
        <span className={cn(req.length && req.letter && req.number ? "text-zinc-600" : "text-zinc-500")}>
          {MIN_PASSWORD_LENGTH}+ chars, letter &amp; number
        </span>
      </div>
    </div>
  );
}
